import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  updateDoc
} from 'firebase/firestore'
import { firestore } from './firebaseClient'

const USERS_COLLECTION = 'Users'
export const USER_ROLES = ['Admin', 'Moderator', 'Manager', 'User']
export const ADMIN_PANEL_ROLES = ['Admin', 'Moderator', 'Manager']

function normalizeUser(user) {
  return {
    ...user,
    name: typeof user.name === 'string' ? user.name.trim() : ''
  }
}

function assertRequiredUserName(name) {
  if (!name || !name.trim()) {
    throw new Error('User name is required.')
  }
}

export async function fetchUsers() {
  const usersQuery = query(collection(firestore, USERS_COLLECTION), orderBy('createdAt', 'desc'))
  const snapshot = await getDocs(usersQuery)
  return snapshot.docs.map(item => normalizeUser({
    uid: item.id,
    ...item.data()
  }))
}

export async function fetchUser(uid) {
  const snapshot = await getDoc(doc(firestore, USERS_COLLECTION, uid))
  if (!snapshot.exists()) return null
  return normalizeUser({
    uid: snapshot.id,
    ...snapshot.data()
  })
}

export async function saveUser(user) {
  const uid = user.uid
  assertRequiredUserName(user.name)
  await setDoc(doc(firestore, USERS_COLLECTION, uid), {
    uid,
    name: user.name.trim(),
    email: user.email,
    role: user.role || 'User',
    image: user.image || '',
    isBlocked: Boolean(user.isBlocked),
    createdAt: user.createdAt || new Date().toISOString(),
    updatedAt: serverTimestamp()
  }, { merge: true })
}

export async function updateUserAccess(uid, patch) {
  const normalizedPatch = { ...patch }
  if (Object.prototype.hasOwnProperty.call(normalizedPatch, 'name')) {
    assertRequiredUserName(normalizedPatch.name)
    normalizedPatch.name = normalizedPatch.name.trim()
  }

  await updateDoc(doc(firestore, USERS_COLLECTION, uid), {
    ...normalizedPatch,
    updatedAt: serverTimestamp()
  })
}
